// A board's first widget keeps the legacy path `/{boardId}` so its derived id - and therefore its
// published URL and any live embed - never changes. Every additional widget gets a `/{boardId}/{key}`
// path with an immutable random key, so renaming a widget can never change its id.
const WIDGET_KEY_LENGTH = 8;

export function buildWidgetPath(boardId: number | string, key?: string | null) {
  return key ? `/${boardId}/${key}` : `/${boardId}`;
}

export function parseWidgetPath(path: string): { boardId: string; key: string | null } {
  const [, boardId = '', key = ''] = path.split('/');

  return { boardId, key: key || null };
}

export function createWidgetKey() {
  const bytes = crypto.getRandomValues(new Uint8Array(WIDGET_KEY_LENGTH / 2));

  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function createWidgetId(secret: string, accountId: number, path: string) {
  const input = `${secret}:${accountId}:${path}`;
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hash = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hash));
  const hex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  return hex.substring(0, 16);
}
